var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DropDownMenu_1;
import React, { Children, cloneElement, Component, forwardRef, Fragment } from 'react';
import { Placement } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, element, eventListener, func, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { AbortableCloseEvent, CloseEvent, OpenEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { getSlot, isFunction, seizeAndForwardChildrenEvents } from '@philips-internal/oswald-ui-utils';
import { CollapseArrow } from '../collapse-arrow/collapse-arrow.js';
import { Popover } from '../popover/popover.js';
import { DropDownMenuAPI } from './drop-down-menu-api.js';
import './drop-down-menu.css';
const HeaderContainer = {
    acceptedTypes: [
        ComponentType.BEHAVIOR,
        ComponentType.DATA_DISPLAY,
        ComponentType.LAYOUT,
    ],
    name: 'header',
};
const ContentContainer = {
    acceptedTypes: [
        ComponentType.BEHAVIOR,
        ComponentType.DATA_DISPLAY,
        ComponentType.NAVIGATION,
        ComponentType.LAYOUT,
    ],
    name: 'content',
};
let DropDownMenu = DropDownMenu_1 = class DropDownMenu extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.shouldClose = () => {
            const { onBeforeClose } = this.props;
            let close = true;
            const abort = () => {
                close = false;
            };
            if (isFunction(onBeforeClose) && this.state.open) {
                onBeforeClose(new AbortableCloseEvent({ abort }));
            }
            return close;
        };
        this.togglePopover = () => {
            const { open } = this.state;
            const { onClose, onOpen } = this.props;
            let triggerEvent;
            if (open) {
                if (!this.shouldClose()) {
                    return;
                }
                triggerEvent = () => isFunction(onClose) && onClose(new CloseEvent());
            }
            else {
                triggerEvent = () => isFunction(onOpen) && onOpen(new OpenEvent());
            }
            this.setState(({ open }) => ({ open: !open }), triggerEvent);
        };
        this.onItemClick = () => {
            this.togglePopover();
        };
    }
    renderHeader() {
        const { open } = this.state;
        const { children, uuid, showChevron } = this.props;
        const childrenArray = Children.toArray(children) || [];
        const header = getSlot(childrenArray, 'header');
        return (React.createElement("div", { className: "c-drop-down-menu__header", onClick: this.togglePopover, slot: "header" },
            React.createElement(Container, { acceptedTypes: HeaderContainer.acceptedTypes, className: "u-expand", slot: HeaderContainer.name, uuid: uuid }, Children.map(header, (child) => cloneElement(child))),
            showChevron && React.createElement(CollapseArrow, { collapsed: !open })));
    }
    renderContent() {
        const { children, uuid } = this.props;
        const childrenArray = Children.toArray(children) || [];
        const content = getSlot(childrenArray, 'content');
        return (React.createElement(Container, { acceptedTypes: ContentContainer.acceptedTypes, className: "c-drop-down-menu__container u-expand", slot: ContentContainer.name, uuid: uuid }, seizeAndForwardChildrenEvents(content, [['onClick', this.onItemClick]])));
    }
    render() {
        const { innerRef, matchTargetWidth = DropDownMenu_1.defaultProps.matchTargetWidth, showArrow = DropDownMenu_1.defaultProps.showArrow, showChevron = DropDownMenu_1.defaultProps.showChevron, } = this.props;
        const { open } = this.state;
        return (React.createElement("div", { className: "c-drop-down-menu", ref: innerRef },
            React.createElement(Popover, { matchTargetWidth: matchTargetWidth, maxHeight: 320, onClose: this.togglePopover, open: open, placement: Placement.BOTTOM, showArrow: showArrow && !showChevron },
                this.renderHeader(),
                React.createElement(Popover.Content, null,
                    React.createElement(Fragment, null, this.renderContent())))));
    }
};
DropDownMenu.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    innerRef: func.notEnumerable(),
    matchTargetWidth: bool,
    onBeforeClose: eventListener,
    onClose: eventListener,
    onOpen: eventListener,
    showArrow: bool,
    showChevron: bool,
    uuid: string,
};
DropDownMenu.defaultProps = {
    matchTargetWidth: true,
    showArrow: true,
    showChevron: true,
};
DropDownMenu = DropDownMenu_1 = __decorate([
    AwesomeComponent({ api: DropDownMenuAPI, containers: [HeaderContainer, ContentContainer], type: ComponentType.NAVIGATION })
], DropDownMenu);
const dropDownMenuWithRef = forwardRef((props, ref) => React.createElement(DropDownMenu, { ...props, innerRef: ref }));
dropDownMenuWithRef.displayName = DropDownMenu.name;
export { dropDownMenuWithRef as DropDownMenu, };
//# sourceMappingURL=drop-down-menu.js.map